import { ReactNode } from 'react';

import styles from './modal-components.module.css';

type ModalFooterProps = {
  children: ReactNode;
};

export const ModalFooter = ({ children }: ModalFooterProps) => {
  return <div className={styles.footer}>{children}</div>;
};
